import { TitleCasePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'breadcrumbs',
  standalone: true,
  imports: [TitleCasePipe],
  template: `
  <nav aria-label="breadcrumb" class="d-flex h-100 align-items center" >
    <ol class="breadcrumb mb-0 d-flex align-items-center">
      @for (breadcrumb of breadcrumbs; track $index) {
        <li class="breadcrumb-item text-black p12">
          @if($index === breadcrumbs.length - 1 || breadcrumb === 'detalhes' || breadcrumb === 'editar' || breadcrumb === 'cadastros') {
            <span>
              {{ breadcrumb | titlecase }}
            </span>
          } @else {
            <span>
              {{ breadcrumb | titlecase }}
            </span>

          }
        </li>
      }
    </ol>
  </nav>
`,
  styleUrl: './breadcrumb.component.scss'
})
export class BreadcrumbComponent {

  private _router = inject(Router);
  private _route = inject(ActivatedRoute);

  // breadcrumbs: Array<{ label: string, url: string }> = [];
  breadcrumbs: Array<string> = [];

  constructor() {
    this._router.events.subscribe(a => {

      if(a instanceof NavigationEnd){
          
          const urlToSplit = a.url;

          const url = urlToSplit.split('/').slice(1); //slice is removing the first and empty url from the original array;

          this.breadcrumbs = url;
      }

  });
    
  }

  private buildBreadcrumbs(): void {
    // this.breadcrumbs 
  }

}
